import { render, staticRenderFns } from "./GameBoardRowComponent.vue?vue&type=template&id=9a737880&"
import script from "./GameBoardRowComponent.vue?vue&type=script&lang=ts&"
export * from "./GameBoardRowComponent.vue?vue&type=script&lang=ts&"
import style0 from "./GameBoardRowComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports